import React, { ReactNode } from "react";
import { Stack, Grid, styled } from "@mui/material";
import { useFormContext, useController } from "react-hook-form";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { selectUser } from "src/store/authSlice";
import { useSelector } from "src/store/Store";
import { Checkbox, TextField } from "./forms";

const StyledQuill = styled((props: any) => <ReactQuill {...props} />)({
  width: "100%",
  ".ql-container": { height: "300px" }
});

const modules = {
  toolbar: [
    //[{ 'font': [] }],
    [{ header: [1, 2, false] }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [
      { list: "ordered" },
      { list: "bullet" },
      { indent: "-1" },
      { indent: "+1" }
    ],
    ["link", "image"],
    [{ align: [] }, { color: [] }, { background: [] }], // dropdown with defaults from theme
    ["clean"]
  ]
};

const formats = [
  //'font',
  "header",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "list",
  "bullet",
  "indent",
  "link",
  "image",
  "align",
  "color",
  "background"
];

const Item = ({
  title,
  requried = false,
  children
}: {
  title: string;
  requried?: boolean;
  children: ReactNode;
}) => {
  return (
    <Stack direction="row" alignItems="center">
      <div style={{ minWidth: "150px" }}>
        {title}
        {requried && <span style={{ color: "red" }}>*</span>}
      </div>
      {children}
    </Stack>
  );
};

function BasicQuillForm() {
  const { name: memberName } = useSelector(selectUser);

  const { control } = useFormContext();

  const { field: titleControl } = useController({
    name: "title",
    control
  });
  const { field: importantControl } = useController({
    name: "important",
    control
  });
  const { field: contentControl } = useController({
    name: "content",
    control
  });

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Item title="제목" requried>
          <TextField
            fullWidth
            size="small"
            value={titleControl.value}
            onChange={titleControl.onChange}
            required
          />
        </Item>
      </Grid>
      <Grid item xs={6}>
        <Item title="작성자" requried>
          <TextField
            fullWidth
            size="small"
            value={memberName}
            InputProps={{
              readOnly: true
            }}
          />
        </Item>
      </Grid>
      <Grid item xs={6}>
        <Item title="중요(상위노출)">
          <Checkbox
            checked={importantControl.value}
            onChange={importantControl.onChange}
          />
        </Item>
      </Grid>
      <Grid item xs={12}>
        <Item title="내용" requried>
          <StyledQuill
            theme="snow"
            modules={modules}
            formats={formats}
            value={contentControl.value}
            onChange={contentControl.onChange}
            placeholder="내용을 입력하세요."
          />
        </Item>
      </Grid>
    </Grid>
  );
}

export default BasicQuillForm;
